import { motion } from "motion/react";
import {
    Box,
    Button,
    Paper,
    TextField,
    Typography,
    InputAdornment,
    IconButton,
} from "@mui/material";

import SmartphoneIcon from "@mui/icons-material/Smartphone";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import { Flip, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { toast_config } from "../toastify/config";
import apiRc from "../../axios/axios";
import LoadingSpinner from "../Spinner";
import { useNavigate } from "react-router-dom";

import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

const LoginAhorrador = () => {

    const navigation = useNavigate();

    const [celular, setCelular] = useState("");
    const [password, setPassword] = useState("");
    const [mostrarPassword, setMostrarPassword] = useState(false);

    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaValido, setCaptchaValido] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const captchaRef = useRef(null);

    const onCaptchaChange = (token) => {
        setCaptchaToken(token);
        setCaptchaValido(!!token);
    };

    const regresar = () => {
        navigation("/");
    };

    const entrar = async () => {

        if (!celular) {
            return toast.error("Es necesario ingresar el número celular", toast_config);
        }

        if (celular.length !== 10) {
            return toast.error("El número celular debe tener 10 dígitos", toast_config);
        }

        if (!password) {
            return toast.error("Es necesario ingresar la contraseña", toast_config);
        }

        if (!captchaValido) {
            return toast.error("Es necesario completar el CAPTCHA", toast_config);
        }

        try {

            setIsLoading(true);

            const datosLogin = {
                celular,
                password,
                captchaToken,
            };

            const { data } = await apiRc.post("/ahorrador/iniciar-sesion", datosLogin,
                {
                    headers: {
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                }
            );
            console.log(data)
            // Guardar JWT
            sessionStorage.setItem("token", data);

            // Ir al home de clientes
            navigation("/home-clientes");

        } catch (error) {

            console.log(error);

            let msg_error = "";

            if (error.response) {

                if (error.response.data?.mensaje) {
                    msg_error = error.response.data.mensaje;
                } else {
                    msg_error =
                        "Ocurrió un error al iniciar sesión, favor de volver a intentarlo.";
                }

            } else {

                msg_error =
                    "No hay respuesta por parte del servidor.";

            }

            // Limpiar CAPTCHA cuando falla el login
            setCaptchaToken(null);
            setCaptchaValido(false);
            captchaRef.current?.reset();

            toast.error(msg_error, toast_config);

        } finally {

            setIsLoading(false);

        }
    };

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",

                backgroundImage: `
                    linear-gradient(
                        rgba(0,0,0,.45),
                        rgba(0,0,0,.45)
                    ),
                    url('/img/loginahorra.png')
                `,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "cover",

                display: "flex",
                justifyContent: {
                    xs: "center",
                    md: "flex-end",
                },
                alignItems: "center",

                pr: {
                    xs: 2,
                    sm: 5,
                    md: "10%",
                    lg: "12%",
                },

                pl: 2,

                overflow: "hidden",
            }}
        >

            {isLoading && <LoadingSpinner />}

            <motion.div
                initial={{
                    opacity: 0,
                    x: 80,
                    scale: 0.95,
                }}
                animate={{
                    opacity: 1,
                    x: 0,
                    scale: 1,
                }}
                transition={{
                    duration: 0.8,
                    easing: "ease-out",
                }}
            >

                <Paper
                    elevation={0}
                    sx={{
                        width: {
                            xs: "100%",
                            sm: 400,
                        },
                        p: 5,
                        borderRadius: 5,
                        backdropFilter: "blur(18px)",
                        background: "rgba(255,255,255,.12)",
                        border: "1px solid rgba(255,255,255,.18)",
                        color: "#FFF",
                    }}
                >

                    <Typography
                        variant="h4"
                        fontWeight="bold"
                        mb={1}
                    >
                        Bienvenido
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,.75)",
                            mb: 4,
                        }}
                    >
                        Inicia sesión para continuar
                    </Typography>

                    {/* CELULAR */}

                    <TextField
                        fullWidth
                        placeholder="Número celular"
                        margin="normal"
                        variant="outlined"
                        value={celular}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setCelular(value);
                        }}
                        inputProps={{
                            maxLength: 10,
                            inputMode: "numeric",
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SmartphoneIcon
                                        sx={{ color: "#FFF" }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                color: "#FFF",
                                borderRadius: 3,
                                background: "rgba(255,255,255,.08)",

                                "& fieldset": {
                                    borderColor:
                                        "rgba(255,255,255,.2)",
                                },

                                "&:hover fieldset": {
                                    borderColor: "#FFF",
                                },

                                "&.Mui-focused fieldset": {
                                    borderColor: "#FFF",
                                },

                                "& input::placeholder": {
                                    color:
                                        "rgba(255,255,255,.7)",
                                    opacity: 1,
                                },
                            },
                        }}
                    />

                    {/* PASSWORD */}

                    <TextField
                        fullWidth
                        type={mostrarPassword ? "text" : "password"}
                        placeholder="Contraseña"
                        margin="normal"
                        variant="outlined"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockOutlinedIcon
                                        sx={{ color: "#FFF" }}
                                    />
                                </InputAdornment>
                            ),

                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() =>
                                            setMostrarPassword(!mostrarPassword)
                                        }
                                        edge="end"
                                        sx={{
                                            color: "rgba(255,255,255,.7)",
                                            "&:hover": {
                                                color: "#FFF",
                                            },
                                        }}
                                    >
                                        {mostrarPassword ? (
                                            <VisibilityOffOutlinedIcon />
                                        ) : (
                                            <VisibilityOutlinedIcon />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                color: "#FFF",
                                borderRadius: 3,
                                background: "rgba(255,255,255,.08)",

                                "& fieldset": {
                                    borderColor: "rgba(255,255,255,.2)",
                                },

                                "&:hover fieldset": {
                                    borderColor: "#FFF",
                                },

                                "&.Mui-focused fieldset": {
                                    borderColor: "#FFF",
                                },

                                "& input::placeholder": {
                                    color: "rgba(255,255,255,.7)",
                                    opacity: 1,
                                },
                            },
                        }}
                    />

                    {/* CAPTCHA */}

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 2,

                            "@media (max-width:400px)": {
                                transform: "scale(0.82)",
                                transformOrigin: "center",
                            },
                        }}
                    >
                        <ReCAPTCHA
                            ref={captchaRef}
                            sitekey={
                                process.env.REACT_APP_RECAPTCHA_SITE_KEY
                            }
                            onChange={onCaptchaChange}
                        />
                    </Box>

                    {/* INICIAR SESIÓN */}

                    <motion.div
                        whileHover={{
                            scale: 1.03,
                        }}
                        whileTap={{
                            scale: 0.97,
                        }}
                    >

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={entrar}
                            sx={{
                                mt: 4,
                                py: 1.5,
                                borderRadius: 3,
                                fontWeight: 700,
                                fontSize: 16,

                                background:
                                    "linear-gradient(135deg,#2EB872,#1B7F52)",

                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg,#36C97D,#208E5B)",
                                },
                            }}
                        >
                            Iniciar sesión
                        </Button>

                    </motion.div>

                    {/* REGRESAR */}

                    <Button
                        fullWidth
                        startIcon={<ArrowBackIcon />}
                        onClick={regresar}
                        sx={{
                            mt: 2,
                            color: "rgba(255,255,255,.8)",
                            textTransform: "none",
                            fontWeight: 500,

                            "&:hover": {
                                color: "#FFF",
                                background:
                                    "rgba(255,255,255,.08)",
                            },
                        }}
                    >
                        Regresar a la página principal
                    </Button>

                </Paper>

            </motion.div>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />

        </Box>
    );
};

export default LoginAhorrador;